import React from 'react';
import { Helmet } from 'react-helmet';
import { Col, Container, Image, Row } from 'react-bootstrap';
import RequestDemoButton from 'components/RequestDemoButton';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import teamWorkImage from 'assets/images/head-start.jpeg';
import styles from './programs.module.scss';
import { SampleReport } from './SampleReport';

const REPORT_DATA = [
  {
    title: '',
    items: [
      'PIR',
      'Head Start Performance Standards',
      'Attendance Details and Summary Reports',
      'Child Information and Assessments',
      'Customizable Demographic Reports',
      'Developmental Assessment Results',
      'Disability Evaluation and Monitoring',
      'Eligibility and EPC Details',
    ],
  },
  {
    title: '',
    items: [
      'Enrollment Details and Wait Lists',
      'Family PIR',
      'Family Details, Referrals, Visits, and Assessments',
      'Health History, Monitoring and Due Dates',
      'Immunization Status Monitoring',
      'Staff Credentials & Training',
      'Meal Counts',
      'USDA Summary and Status Reports',
    ],
  },
];
const REPORT_DATA1 = [
  {
    title: 'Child',
    items: [
      'Accident Report',
      'Developmental Assessments',
      'Disability (Evaluation and IEP) Tracking',
      'Eligibility & EPC Point Calculation',
      'Streamlined ERSEA Enrollment Processes',
      'Growth Assessments',
      'Health Screening & Due Date Reminders',
      'Meal Tracking',
      'Attendance & Classroom Behavior',
      'Monitoring',
      'Immunizations & Reminders',
    ],
  },
  {
    title: 'Family',
    items: [
      'Family Information & PIR Collection',
      'Family Goals and Partnerships',
      'Referrals and Services',
      'Home Visits & Family Observation',
      'Family Partnership Assessment',
      'Water Testing',
      'Prenatal Care',
    ],
  },
  {
    title: 'Classroom',
    items: [
      'Home Based Attendance',
      'Attendance Tracking',
      'Child and Family Member Meal Count',
      'Classroom Observations',
      'Teacher Observation by Brooks Publishing',
    ],
  },
];
// const FEATURE_DATA = [
//   {
//     id: '01',
//     title: 'Program Eligibility Calculator    ',
//   },
//   {
//     id: '02',
//     title: 'Priority Point Matrix',
//   },
//   {
//     id: '03',
//     title: 'Benefit Amount Calculation',
//   },
//   {
//     id: '04',
//     title: 'Automated Payment Creation',
//   },
//   {
//     id: '05',
//     title: 'Real-time Status Tracking',
//   },
//   {
//     id: '06',
//     title: 'Complete Integration with Other Agency Programs',
//   },
//   {
//     id: '07',
//     title: 'Integrated Check Printing System',
//   },
//   {
//     id: '08',
//     title: 'Automated Transmittal to Utility Vendors',
//   },
//   {
//     id: '09',
//     title: 'Track Energy Outreach Activities',
//   },
//   {
//     id: '10',
//     title: 'Unduplicated Client Count',
//   },

//   {
//     id: '11',
//     title: 'Complete Integration with Other Agency Programs',
//   },
//   {
//     id: '12',
//     title: 'Real-time Status Tracking',
//   },
// ];
const FEATURE_DATA = [
  {
    id: '01',
    title: 'Attendance Tracking',
  },
  {
    id: '02',
    title: 'Meal tracking',
  },
  {
    id: '03',
    title: 'Growth Assessments',
  },
  {
    id: '04',
    title: 'PIR Report',
  },
  {
    id: '05',
    title: 'Immunization &amp; Reminders',
  },
  {
    id: '06',
    title: 'ERSEA Enrollment Processes',
  },
  {
    id: '07',
    title: 'Health Screenings',
  },
  {
    id: '08',
    title: 'Home Visit Tracking',
  },
  {
    id: '09',
    title: 'Classroom Observations',
  },
  {
    id: '10',
    title: 'Family Goals &amp; Partnerships',
  },
];
function HeadStart() {
  return (
    <div>
      <Helmet>
        <title>Integrated Head Start Data Management - CAP60</title>
        <meta
          name="description"
          content="Child assessment, development and education are all tracked by the CAP60 Head Start module. Call us Now!."
        />
        <meta name="keywords" content="headstart, cap60 contact" />
      </Helmet>
      <PageBanner
        title="Head Start"
        subtitle="Integrated Head Start Data Management 
        "
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <CommunityServices />
        </Container>
      </div>
      <SampleReport data={REPORT_DATA} className="pb-0" />
      <SampleReport
        data={REPORT_DATA1}
        className="pt-5"
        title="Head Start Modules & Features"
      />
      <div className="floralbg-white">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="primary"
            title="Features"
            subtitle="Dig in to know what make CAP60 Solutions unique and useful."
          />
        </Container>
      </div>
    </div>
  );
}
//
function CommunityServices() {
  return (
    <div className={styles.communityServicesWrap}>
      <Row className="align-items-center">
        <Col md="5">
          <Image src={teamWorkImage} fluid className="p-3 mb-4 mb-md-0" />
        </Col>
        <Col md="7">
          <div className="heading">
            <h2>
              We handle the data management so you can concentrate on teaching
            </h2>
          </div>
          <p>
            The CAP60 Head Start module is a CSBG-integrated data management
            system that tracks all facets of child assessment, development and
            education. Track family data and take advantage of our Class
            observation (from Brooks Publishing) tracking and reporting.
          </p>
          <p>
            CAP60 is the most technologically-advanced system for Process
            Automation, Data Collection and Agency Reporting; designed precisely
            to manage delegate agencies, school districts, programs and
            grantees.
          </p>
          <RequestDemoButton />
        </Col>
      </Row>
    </div>
  );
}

export default HeadStart;
